<template>
  <transition name="guard-fade">
    <div
      v-if="feature"
      class="guard-help-modal__overlay"
      @click.self="$emit('close')"
    >
      <div class="guard-help-modal__box">
        <button class="guard-help-modal__close-x" @click="$emit('close')">
          <svg viewBox="0 0 24 24">
            <path d="M6 6l12 12M18 6 6 18" stroke-linecap="round" />
          </svg>
        </button>

        <transition name="guard-fade" mode="out-in">
          <div v-if="!question" key="questions">
            <div class="guard-help-modal__head">
              <div class="guard-help-modal__icon">
                <img :src="feature.logo" :alt="feature.name" />
              </div>
              <div>
                <div class="guard-help-modal__title">{{ feature.name }}</div>
                <div class="guard-help-modal__sub">
                  Toca una pregunta para ver la respuesta
                </div>
              </div>
            </div>
            <div
              class="guard-help-modal__faq-list"
              v-if="feature.help_questions && feature.help_questions.length"
            >
              <button
                v-for="question in feature.help_questions"
                :key="question.id"
                class="guard-help-modal__faq-item"
                @click="$emit('select-question', question)"
              >
                <span>{{ question.title }}</span>
                <span class="chev">
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M9 6l6 6-6 6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <p v-else class="guard-help-modal__faq-empty">
              No hay preguntas disponibles para esta categoría.
            </p>
          </div>

          <div v-else key="answer">
            <button class="guard-help-modal__back-link" @click="$emit('back')">
              <svg viewBox="0 0 24 24">
                <path
                  d="M15 6l-6 6 6 6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Volver
            </button>
            <div class="guard-help-modal__detail-title">
              {{ question.title }}
            </div>
            <div
              class="guard-help-modal__detail-media"
              v-if="question.video_url"
            >
              <video :src="question.video_url" controls playsinline></video>
            </div>
            <ul
              class="guard-help-modal__detail-steps"
              v-if="formattedSteps.length"
            >
              <li v-for="(step, i) in formattedSteps" :key="i">{{ step }}</li>
            </ul>
            <div class="guard-help-modal__actions">
              <button
                class="guard-help-modal__btn--primary"
                @click="$emit('close')"
              >
                Entendido
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "HelpModal",
  props: {
    feature: {
      type: Object,
      default: null,
    },
    question: {
      type: Object,
      default: null,
    },
  },
  computed: {
    formattedSteps() {
      if (!this.question || !this.question.content) return [];

      //remove special characters, split by lines,remove empty lines
      // and return steps array
      return String(this.question.content)
        .replace(/\\n|\\\\n/g, "\n")
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles";

.guard-help-modal {
  &__overlay {
    @include guard-modal-overlay;
  }
  &__box {
    @include guard-modal-box;
  }
  &__close-x {
    @include guard-close-x;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1.2rem;
    padding-right: 2rem;
  }
  &__icon {
    width: 3rem;
    height: 3rem;
    border-radius: $guard-radius-sm;
    background: $guard-cyan-100;
    @include guard-flex-center;
    overflow: hidden;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 0.3rem;
    }
  }
  &__title {
    font-weight: 700;
    font-size: 1.18rem;
    color: $guard-ink-900;
  }
  &__sub {
    font-size: 0.8rem;
    color: $guard-ink-600;
    margin-top: 0.1rem;
  }

  &__faq-list {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    max-height: 22rem;
    overflow-y: auto;
    padding-right: 0.2rem;
    @include guard-scrollbar(5px);
  }
  &__faq-item {
    @include guard-faq-item;
  }
  &__faq-empty {
    text-align: center;
    color: $guard-ink-600;
    font-size: 0.9rem;
    padding: 1.5rem 0;
  }

  &__back-link {
    @include guard-back-link;
  }

  &__detail-title {
    font-weight: 700;
    font-size: 1.12rem;
    color: $guard-ink-900;
    margin-bottom: 0.9rem;
    padding-right: 1.6rem;
    line-height: 1.3;
  }
  &__detail-media {
    width: 100%;
    max-height: 22rem;
    border-radius: $guard-radius-md;
    overflow: hidden;
    margin-bottom: 1.1rem;
    border: 1px solid $guard-line;
    background: #000;
    @include guard-flex-center;
    video {
      display: block;
      width: 100%;
      height: 100%;
      max-height: 22rem;
      object-fit: contain;
    }
  }
  &__detail-steps {
    @include guard-detail-steps;
  }

  &__actions {
    display: flex;
    gap: 0.65rem;
  }
  &__btn--primary {
    @include guard-modal-btn-primary;
  }
}

.guard-fade-enter-active,
.guard-fade-leave-active {
  transition: opacity 0.18s ease;
}
.guard-fade-enter,
.guard-fade-leave-to {
  opacity: 0;
}
</style>
